/** A client-side persistence write failed (e.g. a Firestore setDoc rejected).
 *  Carries a user-facing message; `cause` is the original error for logging. */
export class PersistenceError extends Error {
  constructor(
    message: string,
    public readonly cause?: unknown,
  ) {
    super(message)
    this.name = 'PersistenceError'
  }
}
